import React, {useContext} from 'react';

// import { Container } from './styles';
import {DragDropContext, Droppable, Draggable} from 'react-beautiful-dnd';
import Cards from '../Cards';
import {useTranslation} from 'react-i18next';
import {Context} from '../../../../Helpers/Auth';

function Colunas({etapa, negocios, setEditarNegocio, onRowClick, setOpenTab}) {
    const {t} = useTranslation();
    const windowWidth = window.innerWidth;
    const minWidth = 1024;
    const getListStyle = isDraggingOver => ({
        backgroundColor: isDraggingOver ? '#DCDFE1' : '',
        border: isDraggingOver && `2px dashed #000`,
        height: 'calc(95%)',
        borderRadius: 10,
        margin: 10,
        width: windowWidth < minWidth ? 275 : 'calc(100%)',
    });

    const handleRowClick = dados => {
        //setEditarNegocio(true);
        onRowClick(dados);
        setOpenTab(3);
    };

    const totalValor = negocios
        .filter(negocio => negocio.etapa === etapa.num)
        .reduce((total, negocio) => total + negocio.valor, 0);

    const filteredNegocios = negocios.filter(
        negocio => negocio.etapa === etapa.num,
    );
    const numberOfCards = filteredNegocios.length;

    const { formatarNumero} = useContext(Context);

    return (
        <Droppable droppableId={etapa.num}>
            {(provided, snapshot) => (
                <div
                    ref={provided.innerRef}
                    style={getListStyle(snapshot.isDraggingOver)}
                    className="max-w-[25%]">
                    <div
                        className={`w-full p-2 text-start bg-blue-500  border bg-${etapa.cor} border-blue-500 rounded-[8px] shadow sm:p-4 dark:bg-red-500 dark:border-red-500`}
                        style={{
                            backgroundColor: etapa.cor,
                            borderColor: etapa.cor,
                        }}>
                            
                        <span className="block mb-2 text-base font-bold text-gray-900 dark:text-white">
                            {etapa.etapa}
                        </span>
                        <div className="flex-row">
                            <span className="font-bold mr-1 text-xs  rounded-full px-1 bg-gray-200 dark:text-black ">
                                {numberOfCards}
                            </span>
                            <span className="font-bold text-xs  rounded-full px-1 bg-gray-200 dark:text-black ">
                                {t(`total`)}:{' '}
                                {/* {new Intl.NumberFormat('de-DE', {
                                    style: 'currency',
                                    currency: 'EUR',
                                }).format(totalValor)} */}
                                {formatarNumero(totalValor)} €
                            </span>
                        </div>
                    </div>
                    <div
                        className={`overflow-y-scroll  mt-4 p-1 ${window.innerHeight <= 700  ? 'max-h-[430px]' : 'max-h-[640px]'}`}
                        // style={{

                        //   overflowY: "scroll",
                        //   height: "95%",
                        //   marginTop: 10,
                        //   padding: 10,
                        // }}
                    >
                        {negocios.map((negocio, index) => {
                            if (negocio.etapa == etapa.num) {
                                return (
                                    <Cards
                                        handleRowClick={handleRowClick}
                                        info={negocio}
                                        index={index}></Cards>
                                );
                            }
                        })}
                    </div>
                    {/* {provided.placeholder} */}
                </div>
            )}
        </Droppable>
    );
}

export default Colunas;
